<template>
    <b-tabs>
        <b-tab title="Tabelle">
            <tbl :competition=competition></tbl>
        </b-tab>

        <b-tab title="Diagramm" :lazy=true>
            <chart :chartData=chartData v-if=chartLoaded></chart>
        </b-tab>
    </b-tabs>
</template>

<script>
import StatsTable from '@/components/competitions/admin/stats/Table'
import StatsChart from '@/components/competitions/admin/stats/Chart'

export default {
  name: 'CompetitionStats',
  components: {
    Tbl: StatsTable,
    Chart: StatsChart
  },
  props: ['competition'],

  data: function () {
    return {
      chartLoaded: false,
      chartData: null
    }
  },

  watch: {
    competition: function () {
      this.loadChart()
    }
  },

  mounted: function () {
    this.loadChart()
  },

  methods: {
    loadChart () {
      if (!this.competition) {
        return
      }

      let total = []
      let online = []
      let paper = []
      let labels = []

      this.axios.get('/competitions/' + this.competition.id + '/chart')
        .then((rsp) => {
          rsp.data.data.forEach((entry) => {
            labels.push(entry.date)

            total.push({
              x: entry.date,
              y: entry.total
            })

            online.push({
              x: entry.date,
              y: entry.online
            })

            paper.push({
              x: entry.date,
              y: entry.paper
            })
          })

          this.chartData = {
            labels: labels,
            datasets: [
              {
                label: 'Gesamt',
                data: total
              },
              {
                label: 'Online',
                data: online
              },
              {
                label: 'Papier',
                data: paper
              }
            ]
          }

          this.chartLoaded = true
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/admin/Stats.vue